<div class="row">
    <div class="dialog">
        <div class="row container">
            <!-- Ganizani -->
            <div class="col-md-8">
                <div class="content">
                    <img src="../../../assets/images/logo_white.png" width="100px"
                        style="display:inline; margin-right: 15px">
                    <!-- <p style="display:inline; white-space:nowrap; font-size: 35px;">ganiSponsorMarket</p> -->
                </div>
            </div>

            <div class="col-md-4 parDiv">
                <p>call us: +27 (0)62 263 1710</p>
            </div>

        </div>
        <hr size="20" width="100%" color="white">
        <h4 class="text-center">Welcome to ganiSponsor Market Place</h4>
        <p class="lead text-center">We are glad to welcome you! How do you want to sign in?</p>
        <!-- <div class="row title">
            
        </div> -->
        <div class="row" style="margin-top: 40px;">
            <div class="col-md-5">
                <h6 class="text-center">Login with Social Network</h6>

                <div class="socialbtn">
                    <div class="linkSocialFB">
                        <a>Sign in with Facebook</a>
                    </div>
                </div>

                <div class="socialbtn">
                    <div class="linkSocial">
                        <a>Sign in with Google</a>
                    </div>
                </div>


            </div>

            <div class="col-md-1">
                <div class="vertical"></div>
            </div>

            <hr class="rounded" size="20" width="90%" color="white">

           

            <div class="col-md-6">
                <h6 class="text-center">Standard Login</h6>
                <form class="row">

                    <div class="form-group col-sm-12">
                        <label for="email">Email </label>
                        <input type="text" class="form-control" id="email" placeholder="email">
                    </div>

                    <div class="form-group col-sm-12">
                        <label for="Password">Password</label>
                        <input type="password" class="form-control" id="password" placeholder="Password">
                    </div>


                    <div class="form-group col-sm-12">

                        <!-- <div class="row d-flex justify-content-center" *ngIf="isLoading" >
                          <img class="loader" src="../../assets/images/loader.gif" width="60px" alt="">
                      </div> -->

                        <div class="row">
                            <div class="col-sm-6">
                                <button type="submit" class="btn btn-primary m-b-1">Login</button>
                            </div>

                            <div class="col-sm-6">
                                <button class="btn btn-primary m-b-1 dialog__close-btn">Close</button>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </div>

        <hr size="20" width="100%" color="white">
        <div class="footer-bottom">
            <div class="container">
                <div class="row">
                       <div class="col-md-6 footer-copyright">
                        <!-- © Bootstrap Footer Template by <a href="#">CHERRY</a> -->
                        © Ganizani Consulting Services
                    </div>
                       <div class="col-md-6 footer-social">
                        <a href="https://facebook.com/ganizaniconsulting" target="_blank"><i class="fa fa-facebook-f"></i></a> 
                        <a href="https://twitter.com/GanizaniConsult" target="_blank"><i class="fa fa-twitter"></i></a> 
                        <a href="#"><i class="fa fa-google"></i></a> 
                        <a href="https://www.instagram.com/ganizaniconsulting" target="_blank"><i class="fa fa-instagram"></i></a> 
                        <a href="#"><i class="fa fa-pinterest"></i></a>
                    </div>
                   </div>
            </div>
        </div>
    </div>
</div>